import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { focusTrap } from '@resy/ui-kitchen';
import filter from 'lodash/filter';
import orderBy from 'lodash/orderBy';
import './AmexGDAHeader.scss';
import SideDrawer from './SideDrawer';
import HeaderNav from './HeaderNav';
import MobileMenu from './MobileMenu';

class AmexGDAHeader extends React.Component {
  state = {
    isScrolled: false,
    sideDrawerOpen: false,
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (window.scrollY > 0) {
      this.setState({ isScrolled: true });
    } else {
      this.setState({ isScrolled: false });
    }
  }

  drawerToggleClickHandler = () => {
    this.setState((prevState) => ({
      sideDrawerOpen: !prevState.sideDrawerOpen,
    }));
  }

  render() {
    const { isScrolled, sideDrawerOpen } = this.state;
    const {
      menuItems = [],
      setScrollForDirMenu,
      mobileMenuContent,
      headerTextImg,
      baseRequestUrl,
      amexFooterImg,
      printContent,
      isGdaMember,
      isGdaEligible,
      isUSLocation,
      hideEvents,
      isEditorialExists,
      hasOriginB2B,
      Analytics,
      hideFAQs,
    } = this.props;

    const updatedMenuItems = menuItems.map((item) => {
      if (item.text === 'Partner Overview') {
        return { ...item, hide: !hasOriginB2B };
      }
      return item;
    });

    let menuItemsToDisplay = filter(updatedMenuItems, { hide: false });

    if (hideEvents) {
      menuItemsToDisplay = filter(menuItemsToDisplay, ((item) => {
        if (item.link !== '#EventsExperiences') {
          return item;
        }
        return null;
      }));
    }

    if (!isEditorialExists) {
      menuItemsToDisplay = filter(menuItemsToDisplay, ((item) => {
        if (item.link !== '#gdaeditorial') {
          return item;
        }
        return null;
      }));
    }

    if (isGdaMember || isGdaEligible) {
      menuItemsToDisplay = filter(menuItemsToDisplay, ((item) => {
        if (item.onlyGdaMember === -1 || item.onlyGdaMember === 1) {
          return item;
        }
        return null;
      }));
    } else {
      menuItemsToDisplay = filter(menuItemsToDisplay, ((item) => {
        if (item.onlyGdaMember === -1 || item.onlyGdaMember === 0) {
          return item;
        }
        return null;
      }));
    }

    if (isUSLocation) {
      menuItemsToDisplay = filter(menuItemsToDisplay, ((item) => {
        if (item.onlyUsCountry === -1 || item.onlyUsCountry === 1) {
          return item;
        }
        return null;
      }));
    } else {
      menuItemsToDisplay = filter(menuItemsToDisplay, ((item) => {
        if (item.onlyUsCountry === -1 || item.onlyUsCountry === 0) {
          return item;
        }
        return null;
      }));
    }

    if (hideFAQs) {
      menuItemsToDisplay = filter(menuItemsToDisplay, ((item) => {
        if (item.text !== 'FAQs') {
          return item;
        }
        return null;
      }));
    }

    // sort menu items based on ID
    menuItemsToDisplay = menuItemsToDisplay.filter((x) => (x !== null));
    const menuItemsOrdered = orderBy(menuItemsToDisplay, ['id'], ['asc']);
    return (
      <>
        <section>
          <header
            className={
              cx('GDA__MobileMenu', {
                'ResyAmexGDAHeader--scrolled': isScrolled,
              })
            }
          >
            <nav aria-label="Primary navigation mobile">
              <MobileMenu
                drawerClickHandler={this.drawerToggleClickHandler}
                show={sideDrawerOpen}
              />
              <SideDrawer
                onAfterClose={focusTrap.focusRemove}
                onAfterOpen={focusTrap.focusModal}
                menuItems={menuItemsOrdered}
                mobileMenuContent={mobileMenuContent}
                show={sideDrawerOpen}
                drawerClickHandler={this.drawerToggleClickHandler}
                setScrollForDirMenu={setScrollForDirMenu}
                headerTextImg={headerTextImg}
                baseRequestUrl={baseRequestUrl}
                amexFooterImg={amexFooterImg}
                printContent={printContent}
                Analytics={Analytics}
                hasOriginB2B={hasOriginB2B}
              />
            </nav>
          </header>
        </section>
        <div className={cx('ResyAmexGDAHeader', {
          'ResyAmexGDAHeader--scrolled': isScrolled,
        })}
        >
          <HeaderNav
            menuItems={menuItemsOrdered}
            setScrollForDirMenu={setScrollForDirMenu}
            printContent={printContent}
            hasOriginB2B={hasOriginB2B}
            Analytics={Analytics}
          />
        </div>
      </>
    );
  }
}

AmexGDAHeader.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  setScrollForDirMenu: PropTypes.func.isRequired,
  mobileMenuContent: PropTypes.objectOf(PropTypes.string).isRequired,
  headerTextImg: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  amexFooterImg: PropTypes.string.isRequired,
  printContent: PropTypes.func.isRequired,
  isGdaMember: PropTypes.bool.isRequired,
  isGdaEligible: PropTypes.bool.isRequired,
  isUSLocation: PropTypes.bool.isRequired,
  hideEvents: PropTypes.bool.isRequired,
  hideFAQs: PropTypes.bool,
  isEditorialExists: PropTypes.bool.isRequired,
  hasOriginB2B: PropTypes.bool.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

AmexGDAHeader.defaultProps = {
  hideFAQs: false,
};

export default AmexGDAHeader;
